import { useMutation, useQuery } from '@tanstack/react-query'
import { chatAttachmentsApi } from '@/api/chatAttachments'
import { useTenantKey } from './useTenantKey'

export function useChatAttachments(projectId: string, chatId: string | null) {
    const tenantKey = useTenantKey()
    return useQuery({
        queryKey: tenantKey('projects', projectId, 'chats', chatId!, 'attachments'),
        queryFn: () => chatAttachmentsApi.getByChat(projectId, chatId!),
        enabled: !!projectId && !!chatId,
        staleTime: 0,
        refetchOnWindowFocus: true,
    })
}

export function useUploadChatAttachments(projectId: string, chatId: string | null) {
    return useMutation({
        // 'always' so an offline paste fails fast instead of pausing forever with the promise
        // unsettled, which would strand the pending-upload count and disable sending.
        networkMode: 'always',
        mutationFn: ({ files, signal }: { files: File[]; signal?: AbortSignal }) => {
            if (!chatId) return Promise.reject(new Error('No active chat selected'))
            return chatAttachmentsApi.upload(projectId, chatId, files, signal)
        },
    })
}

export function useDeleteChatAttachment(projectId: string, chatId: string | null) {
    return useMutation({
        networkMode: 'always',
        mutationFn: (attachmentId: string) => {
            if (!chatId) return Promise.reject(new Error('No active chat selected'))
            return chatAttachmentsApi.delete(projectId, chatId, attachmentId)
        },
    })
}
